import React from 'react';
import { useFormContext } from 'react-hook-form';
import * as styled from './styled/Checkbox.styled';
import { CheckboxInput } from './styled/CheckboxInput.styled';
import { Label } from './styled/Label.styled';

export const Checkbox: React.FC<{
    disabled?: boolean;
    label: string;
    name: string;
}> = ({ disabled = false, label, name }) => {
    const { register } = useFormContext();
    return (
        <styled.Checkbox disabled={disabled}>
            <CheckboxInput disabled={disabled} id={name} {...register(name)}></CheckboxInput>
            <Label htmlFor={name}>{label}</Label>
        </styled.Checkbox>
    );
};
